import { PageType } from "../Types/PageType";
import { Page } from "./Page";
import { CompositeTimeSeriesData } from "./TimeSeriesData";

export class EEGPage extends Page<Map<string, CompositeTimeSeriesData>> {
    getType(): PageType {
        return PageType.EEG
    }

    public invalidateModalityRenderCache(modality: string, propagateBackward: boolean, propagateForward: boolean) {
        // Overridden for EEG data only to prevent invalidating the render cache on load.
        // This allows partial render cache reuse for efficient EEG rendering while maintaining existing cache invalidation behavior.
        if (modality.startsWith("Montage=")) {
            return
        }

        super.invalidateModalityRenderCache(modality, propagateBackward, propagateForward)
    }
}